import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, importProvidersFrom, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './global-composants/footer/footer.component';
import { HeaderComponent } from './global-composants/header/header.component';
import { PrimaryNavComponent } from './global-composants/primary-nav/primary-nav.component';


// Primeng

import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';

import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';

import { PasswordModule } from 'primeng/password';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';
import Aura from '@primeuix/themes/aura';
import { NgxSplideModule } from 'ngx-splide';


import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TreeModule } from 'primeng/tree';

//Material module to add

import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { ProgressBarModule } from 'primeng/progressbar';
import { BienService } from './services/bi/bi.service';
import { ContactsService } from './services/contacts/contacts.services';
import { DocServices } from './services/docs/docs.services';
import { OpeService } from './services/ope/ope.service';
import { PersistanceService } from './services/persistenceStorage/localstorage.service';
import { shareOpeSevices } from './services/sharedservices/shareOpe.services';
import { ScrollService } from './services/Utils/scroll.service';

import { GoogleMapsModule } from '@angular/google-maps';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { KeycloakAngularModule, KeycloakBearerInterceptor, KeycloakService } from 'keycloak-angular';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { EtageService } from './services/bi/etage/etage.service';
import { EntitebackService } from './services/entite/entiteback.service';
import { OptionServices } from './services/options/option.service';
import { SidebarService } from './services/sideBare.service';
import { VilleService } from './services/ville/ville.service';
import { AuthService } from './services/auth/auth.service';
import { ImageCacheService } from './services/imageCache.service';
import { sharePitSevices } from './services/pitupload/sharePit.service';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { GalleriaModule } from 'primeng/galleria';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { FileUploadModule } from 'primeng/fileupload';
import { PaginatorModule } from 'primeng/paginator';
import { loggingInterceptor } from './http-interceptors/logging-interceptor';
import { providePrimeNG } from 'primeng/config';
import { PopoverModule } from 'primeng/popover';

function initializeKeycloak(keycloak: KeycloakService) {

  return () =>
    keycloak.init({
      config: {
        url: environment.host.url_keycloak,
        realm: environment.host.realm_keycloak,
        clientId: environment.host.clientId_keycloak
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        checkLoginIframe: false,
      },

    });
}


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    PrimaryNavComponent
  ],
  imports: [
    PopoverModule,
    AutoCompleteModule,
    BrowserModule,
    AppRoutingModule,
    TableModule,
    TagModule,
    MenuModule,
    BrowserAnimationsModule,
    BadgeModule,
    HttpClientModule,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    MultiSelectModule,
    SliderModule,
    RadioButtonModule,
    CheckboxModule,
    ButtonModule,
    DialogModule,
    TreeTableModule,
    NgxSplideModule,
    ToastModule,
    NgxPaginationModule,
    ProgressBarModule,
    MenubarModule,
    NgOptimizedImage,
    PasswordModule,
    SelectButtonModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    GoogleMapsModule,
    CommonModule,
    TreeModule,
    KeycloakAngularModule,
    AngularEditorModule,
    GalleriaModule,
    ConfirmDialogModule,
    FileUploadModule,
    PaginatorModule
  ],
  providers: [AuthService, MessageService, OptionServices, OpeService, shareOpeSevices, sharePitSevices, VilleService, DocServices, BienService,
    PersistanceService, ContactsService, ScrollService, SidebarService, EtageService, EntitebackService, KeycloakAngularModule, ImageCacheService,
    importProvidersFrom(KeycloakAngularModule),
    KeycloakBearerInterceptor,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    },
    provideHttpClient(
      withInterceptors([loggingInterceptor]),
    ),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none'
        }
      }
    }),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]


})
export class AppModule { }
